import { useMutation, useQueryClient, type UseMutationOptions } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { useContext } from 'react';
import { API } from '@trinity/chat';
import { CreateChartPreferencesRecordContext } from '@trinity/chat-components/containers/ChartPreferences/context';

type CreateRecordData = {
  initialChartType: API.Chat.CreateChartRecord.Request['initialChartType'];
};
type CreateRecordVariables = CreateRecordData;
type CreateRecordOptions = UseMutationOptions<API.Chat.CreateChartRecord.Response, AxiosResponse, CreateRecordVariables>;

export const useCreateChartRecordMutation = (options?: CreateRecordOptions) => {
  const queryClient = useQueryClient();
  const createChartRecord = useContext(CreateChartPreferencesRecordContext);

  return useMutation({
    mutationKey: ['chart-records:create'],
    mutationFn: (data: CreateRecordVariables) => {
      return createChartRecord(data);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ['chart-records:preferences'] });
      queryClient.invalidateQueries({ queryKey: ['chart-records:recent'] });
      options?.onSuccess?.(data, variables, context);
    },
    ...options
  });
};